module.exports = __webpack_public_path__ + "static/media/SocialImage.acabd56c.png";